/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AutoLogin from '@/middleware/autoLogin.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AutoLogin,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/pages/manage-nimble/users',
          name: 'manage-nimble',
          component: () => import('@/views/pages/manage-nimble/ManageNimbleUsers.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Manage Nimble', active: true }
            ],
            pageTitle: 'Manage Nimble',
            rule: 'editor'
          }
        },
        {
          path: '/pages/hr-people',
          name: 'hr-people',
          component: () => import('@/views/pages/hr-people/StaffRecord.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'HR & People', active: true }
            ],
            pageTitle: 'HR & People',
            rule: 'editor'
          }
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-user',
          name: 'page-supplier-user',
          component: () => import('@/views/pages/supplier-manage/ManageSupplierUser.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-profile',
          name: 'page-supplier-user-profile',
          component: () => import('@/views/pages/supplier-manage/SupplierProfile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Supplier Profile', active: true }
            ],
            pageTitle: 'Supplier Profile',
            rule: 'editor'
          }
        },
        {
          path: '/pages/raw-materials',
          name: 'raw-materials',
          component: () => import('@/views/pages/supplier-manage/RawMaterialHome.vue'),
          children: [
            // {
            //   path: '',
            //   name: 'raw-materials-home',
            //   component: () => import('@/views/pages/supplier-manage/ManufacturingSiteSelect.vue'),
            //   meta: {
            //     parent: 'raw-materials',
            //     breadcrumb: [
            //       { title: 'Home', url: '/' },
            //       { title: 'Manufacturing Sites', active: true }
            //     ],
            //     pageTitle: 'Select Manufacturing Site',
            //     rule: 'editor'
            //   }
            // },
            {
              path: '',
              name: 'raw-materials-list',
              component: () => import('@/views/pages/supplier-manage/RawMaterialManage.vue'),
              meta: {
                parent: 'raw-materials',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw Materials', active: true }
                ],
                pageTitle: 'Raw Materials',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'supplier-raw-materials',
              component: () => import('@/views/pages/supplier-manage/manage-raw-materials/ManufactureDetailsView.vue'),
              meta: {
                parent: 'raw-materials',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw Materials' , url: '/pages/raw-materials' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Raw Material Details',
                rule: 'editor'
              }
            },
          ]
        },
        {
          path: '/pages/supplier-manufacturing',
          name: 'supplier-manufacturing',
          component: () => import('@/views/pages/supplier-manage/ManufacturingManage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', active: true }
            ],
            pageTitle: 'Manufacturing Sites',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing/create',
          name: 'supplier-manufacturing-create',
          component: () => import('@/views/pages/supplier-manage/manage-manufacturing-create/ManufactureDetailsView.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', url: '/pages/supplier-manufacturing' },
              { title: 'Create', active: true }
            ],
            pageTitle: 'Manufacturing Site Create',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing/:id',
          name: 'supplier-manufacturing-view',
          component: () => import('@/views/pages/supplier-manage/manage-manufacturing/ManufactureDetailsView.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', url: '/pages/supplier-manufacturing' },
              { title: 'Supplier Manufacturing Details', active: true }
            ],
            pageTitle: 'Manufacturing Site Details',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing-create',
          name: 'manufacturing-create',
          component: () => import('@/views/SupplierForm.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            // pageTitle: 'Create Manufacturing Form',
            rule: 'editor'
          }
        },
        {
          path: '/pages/trading-summary/rm-orders',
          name: 'rm-orders',
          component: () => import('@/views/pages/trading-summary/rm-orders/RMOrdersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Raw Material Orders', active: true},
            ],
            pageTitle: 'Raw Material Orders',
            rule: 'editor'
          }
        },
        {
          path: '/pages/trading-summary/rm-orders/:id',
          name: 'rm-orders-details-view',
          component: () => import('@/views/pages/trading-summary/rm-orders/RmOrderDetailsView.vue'),
          meta: {
            parent: 'rm-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Raw Material Order Details', active: true},
            ],
            pageTitle: 'Raw Material Order Details',
            rule: 'editor'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      redirect: '/page/login',
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/pages/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue')
        },
        {
          path: '/pages/email-verification/:code',
          name: 'page-verification',
          component: () => import('@/views/pages/EmailVerification.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
